/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-10",
    versionChannel: "nightly",
    buildDate: "2023-07-10T00:23:25.536Z",
    commitHash: "f5b4fbce77b229de1df1738cd6375079c3b3bd3b",
};
